<template lang="pug">
div(v-if="cadastroOriginal")
  el-tabs.tabs(
    @tab-click="handleClick",
    v-model="abaAtiva",
  )
    cadastro-uc(
      :dadosJson="dadosJson"
    )

    el-tab-pane.tab(name='qualificacao')
      span(slot='label')
        | Geral &nbsp
      informacao-desejada(v-if="isInformacao", :informacaoDesejada="cadastroOriginal.informacaoDesejada", :tipo="processo.tipo.nome", :dataCadastro="processo.dataCadastro")
      informacoes-qualificacao-permuta(v-if="isPermuta", :qualificacao="cadastroOriginal.qualificacao", :tipo="processo.tipo.nome", :dataCadastro="processo.dataCadastro" :cadastroOriginal="cadastroOriginal", :compararQualificacaoPermuta="compararRetificacoes && compararRetificacoes.mudouQualificacaoDTO")
      informacao-desejada(v-if="!isInformacao && !isPermuta", :informacaoDesejada="cadastroOriginal", :tipo="processo.tipo.nome", :dataCadastro="processo.dataCadastro", :withOutQualificacao="true")

    el-tab-pane.tab(name='cadastrante')
      span(slot="label")
        | Cadastrante &nbsp
      informacoes-cadastrante(
        :cadastrante="cadastrante",
        :tipoProcesso="tipoProcesso"
        v-if="!isAreasPatrimoniais",
        :compararCadastante="compararRetificacoes && compararRetificacoes.mudouCadastranteDTO"
      )
      div(v-for = "membro in cadastrante.membrosComunidade")
        informacoes-cadastrante(
          :cadastrante="membro",
          :isOnerosoGroup="isOnerosoGroup",
          :tipoProcesso="tipoProcesso",
          :dadosJson="dadosJson"
          v-if="isMembrosComunidade"
        )
        app-divider

      informacoes-cadastrante-areas-patrimoniais(
        :cadastroOriginal="cadastroOriginal",
        v-if="isAreasPatrimoniais"
        :compararCadastranteAreasPatrimoniais="compararRetificacoes && compararRetificacoes.mudouCadastranteDTO"
      )

      listagem-documentos(
        v-if="cadastrante.documentos && cadastrante.documentos.length > 0"
        :documentos="cadastrante.documentos",
        :protocoloCadastroOriginal="cadastroOriginal.protocolo"
        ownerDocumento="CADASTRANTE"
        :compararDocumentos="compararRetificacoes && compararRetificacoes.mudouCadastranteDTO"
        :versaoCadastro = "versaoCadastro"
      )
    el-tab-pane.tab(name='interessado', v-if="!isReurbColetivo")
      span(slot="label")
        | Interessado &nbsp
      informacoes-interessado(
        v-if="!isAreasPatrimoniais",
        :interessado="interessado",
        :idCadastro="this.processo.numeroProtocolo"
        :compararInteressado="compararRetificacoes && compararRetificacoes.mudouInteressadoDTO"
      )

      informacoes-interessado-areas-patrimoniais(
        :interessado="interessado",
        v-if="isAreasPatrimoniais"
        :compararInteressadoAreasPatrimoniais="compararRetificacoes && compararRetificacoes.mudouInteressadoDTO"
      )

      listagem-documentos(
        v-if="interessado.documentos && interessado.documentos.length > 0"
        :documentos="interessado.documentos",
        :protocoloCadastroOriginal="cadastroOriginal.protocolo"
        ownerDocumento="INTERESSADO"
        :compararDocumentos="compararRetificacoes && compararRetificacoes.mudouInteressadoDTO"
        :versaoCadastro = "versaoCadastro"
      )

    el-tab-pane.tab(name='imovel', v-if="!isAreasPatrimoniais")
      span(slot="label")
        | Imóvel &nbsp
      informacoes-imovel-permuta(
        v-if="isPermuta",
        :imovel="imovel"
        :compararImovelPermuta="compararRetificacoes && compararRetificacoes.mudouImovelDTO"
      )

      informacoes-imovel-solicitacao(
        v-if="isInformacao",
        :imovel="imovel"
        :compararImovelSolicitacao="compararRetificacoes && compararRetificacoes.mudouImovelDTO"
      )

      informacoes-aforamento-imovel(
        v-if="isAforamento",
        :imovel ='imovel'
        :compararAforamentoImovel="compararRetificacoes && compararRetificacoes.mudouImovelDTO"
      )

      informacoes-imovel-transferencia(
        v-if="isTransferenciaDireitos",
        :imovel="imovel"
        :compararImovelTransferencia="compararRetificacoes && compararRetificacoes.mudouImovelDTO"
      )

      informacoes-imovel-cancelamento(
        v-if="isCancelamento",
        :imovel="imovel",
        :dadosProcessoFisico="dadosProcessoFisico"
        :compararImovelCancelamento="compararRetificacoes && compararRetificacoes.mudouImovelDTO"
      )

      informacoes-reurb-coletivo-imovel(
        v-if="isReurbColetivo",
        :imovel ='imovel'
      )

      listagem-documentos(
        v-if="imovel.documentos && imovel.documentos.length > 0"
        :documentos="imovel.documentos",
        :protocoloCadastroOriginal="cadastroOriginal.protocolo"
        ownerDocumento="IMOVEL"
        :compararDocumentos="compararRetificacoes && compararRetificacoes.mudouImovelDTO"
        :versaoCadastro = "versaoCadastro"
      )

    el-tab-pane.tab(name='georreferenciamento' v-if="!isInformacao && !isCancelamento")
      span(slot="label")
        | Georreferenciamento &nbsp
      app-resumo-geo(
        :localizacao="processoRelatorio.geometria"
        :geo="georreferenciamento",
        :id-mapa="`mapaResumo${georreferenciamento.id}`",
        v-if="abaAtiva === 'georreferenciamento'",
        :exibeDocumentos="false",
        :isVisualizarCadastro="true",
        :isGeoBeneficiario="false",
        :idCadastro="processo.numeroProtocolo"
        :isCadastroOff="georreferenciamento.localizacoes && georreferenciamento.localizacoes.length > 0 && !!georreferenciamento.localizacoes[0].geometry"
        :idProcesso="idProcesso"
        :compararResumoGeo="compararRetificacoes && compararRetificacoes.mudouGeorreferenciamentoDTO"
      )

      listagem-documentos(
        v-if="(georreferenciamento.documentos && interessado.documentos.length > 0) || (processo.documentosAutenticaveis && processo.documentosAutenticaveis.length > 0)"
        :documentos="georreferenciamento.documentos",
        :protocoloCadastroOriginal="cadastroOriginal.protocolo"
        :documentosGeo="processo.documentosAutenticaveis",
        ownerDocumento="GEO"
        :compararDocumentos="compararRetificacoes && compararRetificacoes.mudouGeorreferenciamentoDTO"
        :versaoCadastro = "versaoCadastro"
      )
    el-tab-pane.tab(name='termoCompromisso')
      span(slot="label")
        | Termo de compromisso &nbsp
      informacoes-termo-compromisso(
        :isCancelamentoClausulaResolutiva="isCancelamentoClausulaResolutiva"
        :isReurb="isReurb"
      )

</template>

<script>
import { mapActions } from 'vuex'

import AppDisplay from '@/components/AppDisplay'
import AppButton from '@/components/AppButton'
import AppResumoGeo from '@/components/resumo/AppResumoGeo'

import ListagemDocumentos from '@/components/informacoesCadastro/ListagemDocumentos'

import CadastroUc from '@/components/informacoesCadastro/cadastrosOnline/CadastroUc'
import InformacoesCadastrante from '@/components/informacoesCadastro/cadastrosOnline/InformacoesCadastrante'
import InformacoesInteressado from '@/components/informacoesCadastro/cadastrosOnline/InformacoesInteressado'
import InformacoesImovel from '@/components/informacoesCadastro/cadastrosOnline/InformacoesImovel'
import InformacoesTermoCompromisso from '@/components/informacoesCadastro/InformacoesTermoCompromisso'
import InformacaoDesejada from '@/components/informacoesCadastro/cadastrosOnline/solicitacaoInformacao/InformacaoDesejada'
import InformacoesImovelSolicitacao from '@/components/informacoesCadastro/cadastrosOnline/solicitacaoInformacao/InformacoesImovelSolicitacao'
import InformacoesAforamentoImovel from '@/components/informacoesCadastro/cadastrosOnline/informacoesAforamento/InformacoesAforamentoImovel'
import InformacoesReurbColetivoImovel from '@/components/informacoesCadastro/cadastrosOnline/informacoesReurbColetivo/InformacoesReurbColetivoImovel'
import InformacoesQualificacaoPermuta from '@/components/informacoesCadastro/cadastrosOnline/informacoesPermuta/InformacoesQualificacaoPermuta'
import InformacoesImovelPermuta from '@/components/informacoesCadastro/cadastrosOnline/informacoesPermuta/InformacoesImovelPermuta'
import InformacoesImovelTransferencia from '@/components/informacoesCadastro/cadastrosOnline/transferenciaDireitos/InformacoesImovelTransferencia'
import InformacoesImovelCancelamento from '@/components/informacoesCadastro/cadastrosOnline/cancelamentoClausula/InformacoesImovelCancelamento'
import InformacoesCadastranteAreasPatrimoniais from '@/components/informacoesCadastro/cadastrosOnline/areasPatrimoniais/InformacoesCadastranteAreasPatrimoniais'
import InformacoesInteressadoAreasPatrimoniais from '@/components/informacoesCadastro/cadastrosOnline/areasPatrimoniais/InformacoesInteressadoAreasPatrimoniais'

export default {

  components: {
    AppDisplay,
    AppButton,
    InformacoesCadastrante,
    InformacoesInteressado,
    InformacoesImovel,
    AppResumoGeo,
    ListagemDocumentos,
    InformacaoDesejada,
    InformacoesImovelSolicitacao,
    InformacoesAforamentoImovel,
    InformacoesQualificacaoPermuta,
    InformacoesReurbColetivoImovel,
    InformacoesImovelPermuta,
    InformacoesImovelTransferencia,
    InformacoesCadastranteAreasPatrimoniais,
    InformacoesInteressadoAreasPatrimoniais,
    InformacoesTermoCompromisso,
    InformacoesImovelCancelamento,
    CadastroUc
  },

  props: {
    processoRelatorio: {
      type: Object,
      default: undefined
    },
    idProcesso: {
      type: Number,
      required: true
    },
    dadosJson: {
      required: false
    },
    compararRetificacoes: {
      type: Object,
      required: false
    },
    versaoCadastro: {
      type: String,
      default: 'MAX(versao_json)'
    }
  },

  data () {
    return {
      abaAtiva: '',
      processo: null
    }
  },

  async created () {
    this.processo = this.processoRelatorio ? this.processoRelatorio : await this.getProcesso(this.$route.params.idCadastro)

    if (this.isInformacao || this.isPermuta || this.isTransferenciaDireitos || this.isAforamento || this.isCancelamento) {
      this.abaAtiva = 'qualificacao'
    } else {
      this.abaAtiva = 'cadastrante'
    }
  },

  computed: {
    cadastroOriginal () {
      if (!this.processo) {
        return null
      }

      return { ...this.processo.dadosCadastro, protocolo: this.processo.numeroProtocolo, tipo: this.processo.tipo.codigo }
    },

    isCancelamentoClausulaResolutiva () {
      return ['CANCELAMENTO_CLAUSULA_RESOLUTIVA']?.includes(this?.processo?.tipo?.codigo)
    },

    isReurb () {
      return ['REURB_COLETIVO', 'REURB_INDIVIDUAL']?.includes(this?.processo?.tipo?.codigo)
    },

    cadastrante () {
      return this.cadastroOriginal.cadastrante
        ? this.cadastroOriginal.cadastrante : {}
    },

    interessado () {
      return this.cadastroOriginal.interessado.pessoa
        ? this.cadastroOriginal.interessado : {}
    },

    imovel () {
      return this.cadastroOriginal.imovel
        ? this.cadastroOriginal.imovel : {}
    },

    dadosProcessoFisico () {
      const { numeroTituloDominial, numeroProcesso, dataEmissaoTituloDominial } = this.processo.dadosCadastro
      return { numeroTituloDominial, numeroProcesso, dataEmissaoTituloDominial }
    },

    georreferenciamento () {
      return this.cadastroOriginal.georreferenciamento ? this.cadastroOriginal.georreferenciamento : {}
    },

    localizacoes () {
      return this.cadastroOriginal.georreferenciamento.localizacoes
        ? this.cadastroOriginal.georreferenciamento.localizacoes : []
    },

    isInformacao () {
      return this.cadastroOriginal.tipo === 'INFORMACOES'
    },

    tipoProcesso () {
      return this.cadastroOriginal.tipo
    },

    isReurbColetivo () {
      return this.cadastroOriginal.tipo === 'REURB_COLETIVO'
    },

    isUc () {
      return this.cadastroOriginal?.tipo === 'UC'
    },

    isAforamento () {
      return this.cadastroOriginal.tipo === 'AFORAMENTO'
    },

    isTransferenciaDireitos () {
      return this.cadastroOriginal.tipo === 'TRANSFERENCIA_DIREITOS'
    },

    isAreasPatrimoniais () {
      return this.cadastroOriginal.tipo === 'AREAS_PATRIMONIAIS'
    },

    isPermuta () {
      return this.cadastroOriginal.tipo === 'PERMUTA'
    },

    isCancelamento () {
      return this.cadastroOriginal.tipo === 'CANCELAMENTO_CLAUSULA_RESOLUTIVA'
    },
    isMembrosComunidade () {
      return this.cadastrante.tipo === 'MEMBROS_DA_COMUNIDADE'
    }
  },

  methods: {
    ...mapActions({
      getProcesso: 'processos/getProcessoByProtocolo'
    }),

    handleClick (tab) {
      this.abaAtiva = tab.name
    },

    async getProcessoAtualizado () {
      this.processo = this.processoRelatorio ? this.processoRelatorio : await this.getProcesso(this.$route.params.idCadastro)
    }
  },

  watch: {
    processoRelatorio: {
      async handler (val) {
        this.getProcessoAtualizado()
      }
    }
  }

}
</script>
<style lang="scss" scoped>
  span {
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/cadastrosOnline/InformacoesCadastroOnline.vue